/* ============
 * Vuex Store
 * ============
 *
 * The store of the application.
 *
 * http://vuex.vuejs.org/en/index.html
 */

import Vue from "vue";
import Vuex from "vuex";
import SecureLS from "secure-ls";
var ls = new SecureLS({ isCompression: false });
import createPersistedState from "vuex-persistedstate";
// Modules
import commonState from "./modules/commonState";
import loginState from "./modules/loginState";

Vue.use(Vuex);

const debug = process.env.NODE_ENV !== "production";

export default new Vuex.Store({
  /**
   * Assign the modules to the store.
   */
  modules: {
    commonState,
    loginState,
  },

  /**
   * If strict mode should be enabled.
   */
  strict: debug,
  plugins: [
    createPersistedState({
      storage: {
        getItem: (key) => ls.get(key),
        setItem: (key, value) => ls.set(key, value),
        removeItem: (key) => ls.remove(key),
      },
    }),
  ],
  secure: true,
  state: {},
  mutations: {},
  actions: {},
});
